import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';

const savedLanguage = localStorage.getItem('language');
const initialLanguage = savedLanguage === 'en' || savedLanguage === 'es' ? savedLanguage : 'es';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en }
    },
    lng: initialLanguage,
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    returnNull: false
  });

document.documentElement.lang = initialLanguage;

export default i18n;
